import React, { Component } from "react"

import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { CHOICE } from "../constants/status"

const timerProps = {
    isPlaying: true,
    size: 120,
    strokeWidth: 15
}

const CHOICE_MAX = 15 + 1
const GAME_MAX = 10 + 1

class UvpTimer extends Component {
    constructor() {
        super()
        this.state = {
            show: true
        }
    }

    renderTime = (value) => {

        const { status } = this.props
        const max = status === CHOICE ? CHOICE_MAX : GAME_MAX

        const time = (max - value) | 0

        return (
            <div className="time-text">{time}</div>
        )
    }

    render = () => {

        const { status, currentTime, hide, innerTimeShow } = this.props

        const choice = status === CHOICE

        const max = choice ? CHOICE_MAX : GAME_MAX
        const colorsTime = [max * 0.7, max * 0.4, max * 0.01]
        
        const style = parseInt(currentTime) < 6 && parseInt(currentTime) > 0 ? "animated" : ""

        if (currentTime > 0) {
            return (
                <div className={`timer`}>
                    {
                        innerTimeShow ?
                            <CountdownCircleTimer
                                isPlaying={true}
                                size={120}
                                strokeWidth={15}
                                colors={['#448b03ff', '#dba504ff', '#a20101ff']}
                                colorsTime={colorsTime}
                                duration={max}
                                key={`${status}-${max}`}
                                trailColor='rgba(255, 255, 255, 0.2)'
                                initialRemainingTime={currentTime}
                                onComplete={() => {
                                    hide()
                                    return { shouldRepeat: false }
                                }}
                            >
                                {({ remainingTime, color }) => (
                                    <span style={{ color: "white" }} className={`timer-text ${style}`}>
                                        {remainingTime}
                                    </span>
                                )}
                            </CountdownCircleTimer>

                            : null
                    }


                </div>
            )
        }

        return null

    }

}

export default UvpTimer